import Cookies from 'js-cookie';

export default class Launguage {
  /**
   * 現在の言語がJPか判定.
   * @returns {boolean}
   */
  static isJp() {
    return Cookies.get('lang') !== 'en';
  }

  /**
   * 現在の言語がENか判定.
   * @returns {boolean}
   */
  static isEn() {
    return Cookies.get('lang') === 'en';
  }
}
